import addToCart from '../lib/addToCart';
import toggleAtcNotification from '../lib/toggleAtcNotification';

let quickBuyDelegated = false;

const initQuickBuy = () => {
  if (quickBuyDelegated) return;
  quickBuyDelegated = true;

  document.body.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-buy]');
    if (!btn || btn.tagName !== 'BUTTON') return;
    e.preventDefault();
    const variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!variantId || Number.isNaN(variantId)) return;

    btn.disabled = true;
    btn.classList.add('pointer-events-none', 'opacity-50');
    try {
      const res = await addToCart([{ id: variantId, quantity: 1 }]);
      if (res?.items?.length) {
        toggleAtcNotification(res);
      }
    } catch (err) {
      console.error('Add to cart (card) error:', err);
    } finally {
      btn.disabled = false;
      btn.classList.remove('pointer-events-none', 'opacity-50');
    }
  });
};

export default initQuickBuy;
